import { CardContent, CardHeader, Stack } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import MaterialButton from "../../../components/MaterialButton"
import MaterialTypography from "../../../components/MaterialTypography"
import { Add, FileUpload, FilterAlt } from "@mui/icons-material"
import Table from "../../../components/Table"
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { deleteData, fetchData, postData } from "../../../services"
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index";
import { useSnackbar } from "../../../context/popup"
import UploadFile from "../../Utils/UploadFile"
import { useLoading } from "../../../components/Loading"
import GeneralFinanceFilterDialog from "./components/GeneralFinanceFilterDialog.js";


const FinanceList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    const currentPage = useSelector((state) => state?.generalBankStore?.currentPage);
    const rowsPerPage = useSelector((state) => state?.generalBankStore?.rowsPerPage);
    const totalPages = useSelector((state) => state?.generalBankStore?.totalPages);

    const [financerList, setFinancerList] = useState([]);
    const [isRefresh, setIsRefresh] = useState(false);
    const [openUploadFileDialog, setOpenUploadFileDialog] = useState(false);
    const [fileUploading, setFileUploading] = useState(false);
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const [clearFileOnSuccess, setClearFileOnSuccess] = useState(false);
    const [search, setSearch] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [filterData, setFilterData] = useState({
        isActive: "",
    });

    useEffect(() => {
        fetchFinanceList();
    }, [isRefresh, currentPage, rowsPerPage, search]);

    //API List
    const fetchFinanceList = async () => {
        setCircleLoading(true);
        try {
        let url = `/reference/general/financer-list-master?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}`;
                    
        //for active and inactive status
        if(filterData.isActive !== "") {
            url += `&isActive=${filterData.isActive}`;
        }

        const response = await fetchData(url);
        
        if(response?.success){
            setFinancerList(response?.data?.items)
            dispatch(setTotalPages(response?.data?.totalPages));
        }
        else{
            //throw error
            showSnackbar("Error fetching Financer List", "error")
        }
        } catch (error) {
            console.error('Error Fetching List:', error);
            showSnackbar(error?.response?.data?.message || 'Network Error', "error");
        }
        finally{
            setCircleLoading(false);
        }
    };

    //bulk file upload api function
    const handleFileUploadSuccess = async (file) => {
        setFileUploading(true)
        setUploadSuccess(false)

        try {
            const formData = new FormData()

            formData.append('file', file)

            const result = await postData(`/reference/master/bulkUpload/general-financer-list`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });        

            if (result?.success) {
                setUploadSuccess(true)
                showSnackbar(result?.message,"success");
                setOpenUploadFileDialog(false);
                setClearFileOnSuccess(true);
                fetchFinanceList(); 
            }
            else {
                setUploadSuccess(false);
                showSnackbar('Faiiled to upload file', "error")
            }

        } catch (error) {
            const errorMessage = error?.response?.data?.message;                
            console.error('Upload error:', error || errorMessage)
            showSnackbar(errorMessage, "error")
        } 
        finally {
            setFileUploading(false)
        }
    };

    //delete api function
    const handleDelete = async (row) => {
        try {
            const response = await deleteData(`/reference/general/financer-list-master-delete`, {ids:[row?.id]});
            setIsRefresh(!isRefresh);
            if(response?.success){
                showSnackbar(response?.message, "success");
            }
            else{
                showSnackbar(response?.message, "error");
            }
        } catch (error) {
            console.error("Error deleting data:", error);
            showSnackbar(error?.response?.data?.message, "error");
        }
    };

    //table mapping
    const financerListTable = {
        columns: [
            {
            key: "sno",
            label: "S.No.",
            renderCell: (row) => row.sno,
            },
            {
            key: "name",
            label: "Financer Name",
            renderCell: (row) => row.name,
            },
            {
            key: "sortOrder",
            label: "Sort Order",
            renderCell: (row) => row.sortOrder,
            },
            {
            key: "createdAt",
            label: "Created At",
            renderCell: (row) => row.createdAt,
            },
            {
                key: "isActive",
                label: "Status",
                renderCell: (row) => (
                    <span>
                    {row.isActive ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
                    ) : (
                        <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
                    )}
                    </span>
                )
            },
        ],
        rows: financerList?.map((financer, index) => ({
            id: financer?.id,
            sno: index + 1,
            name: financer?.name || "",
            sortOrder: financer?.sortOrder ?? 0,
            isActive: financer?.isActive,
            deleted: financer?.deleted,
            createdAt: financer?.createdAt
            ? new Date(financer.createdAt).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                })
            : "",
            updatedAt: financer?.updatedAt
            ? new Date(financer.updatedAt).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                })
            : "",
        })),
    };

    const handleAddNewFinancer = () => {
        navigate(`/general-master/financer-list/financer-details`);
    }

    const handlePaginationChange = (page) => {
        dispatch(setCurrentPage(page));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        dispatch(setRowsPerPage(rowsPerPage));
        dispatch(setCurrentPage(1));
    };

    const actions = {
        edit: true,
        view: true,
        delete: true,

        onEdit: (row) => {
            navigate(`/general-master/financer-list/financer-details?pageType=edit&id=${row.id}`);
        },
        onView: (row) => {
            navigate(`/general-master/financer-list/financer-details?pageType=view&id=${row.id}`);
        },
        onDelete: (row) => handleDelete(row),
    };

    const handleSearch = (value) => {
        setSearch(value);
    };

  return (
    <DashboardLayout>
        <CardHeader title={(
                <Stack
                    direction={{ xs: "column", sm: "row" }}
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                >
                    <Stack direction="column" spacing={0}>
                        <MaterialTypography variant="h5" fontWeight="medium">
                            Financer List
                        </MaterialTypography>
                        <MaterialTypography variant="caption" color="text">
                            View and manage the list of Financers.
                        </MaterialTypography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                        <MaterialButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        startIcon={<FilterAlt/>}
                        onClick={(event) => setAnchorEl(event.currentTarget)}
        
                        >
                        Filter
                        </MaterialButton>
                        <MaterialButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        startIcon={<FileUpload/>}
                        onClick={() => setOpenUploadFileDialog(true)}>
                            Bulk Upload
                        </MaterialButton>
                        <MaterialButton
                            variant="gradient"
                            color="dark"
                            size="small"
                            startIcon={<Add />}
                            onClick={() => handleAddNewFinancer()}
                        >
                            Financer
                        </MaterialButton>
                    </Stack>
                </Stack>


            )} 
        />
        <CardContent>
            <Table
            columns={financerListTable?.columns}
            data={financerListTable?.rows}
            actions={actions}
            pagination={{
                totalPages,
                currentPage,
                onPageChange: (page) => handlePaginationChange(page),
                rowsPerPage,
                onRowsPerPageChange: (rowsPerPage) => handleRowsPerPageChange(rowsPerPage),
                rowsPerPageOptions: [5, 10, 15, 20],
            }}
            getRowKey={(row) => row.id}
            className="custom-table"
            noDataLabel="No Financers found" 
            handleSearch={handleSearch}           
            />
        </CardContent>
        <UploadFile
        open={openUploadFileDialog}
        setOpen={setOpenUploadFileDialog}
        onUploadSuccess={handleFileUploadSuccess}
        fileTypes={['csv', 'xlsx']}
        fileUploading={fileUploading}
        uploadSuccess={uploadSuccess}
        setUploadSuccess={setUploadSuccess}
        setFileUploading={setFileUploading}
        clearFileOnSuccess={clearFileOnSuccess}
        />
        <GeneralFinanceFilterDialog
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        filterData={filterData}
        setFilterData={setFilterData}
        onApply={() => {
            setAnchorEl(null);   // close popup
            fetchFinanceList();  // call API after filter applied
        }}
        />
    </DashboardLayout>
  )
}

export default FinanceList